<template>
  <div>
    <div v-for="(item, index) in value" :key="index" class="horizontal-input-layout mt2">
      <span class="horizontal-input-label">{{ item[0] }}:</span>
      <input class="text-input bg-middle horizontal-input-data data-layout" type="text"
        :value="item[1]"
        @input="updateItem(index, $event)"
      >
      <span style="color: red" v-for="e in item.errors" v-bind:key="e" class="horizontal-input-error">{{e}}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: ['value'],
  methods: {
    updateItem (index, event) {
      this.$emit('input', this.value.map((curItem, curIndex) => {
        return index === curIndex
          ? [curItem[0], event.target.value]
          : curItem
      }))
    }
  },
  data () {
    return {
      error: false
    }
  }
}
</script>

<style>
.data-layout {
  display: grid;
  grid-template-columns: 3px 1fr;
  grid-template-rows: auto;
  align-items: center;
  min-height: 40px;
}
</style>
